import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  Shimmer,
  ShimmerSize,
  ShimmerType,
  ShimmerLength
} from '../../components/shimmer/shimmer';
import bemify from '../../utils/bemUtils';
import withConfig from '../../hoc/withConfig';


/**
 * Represents the skeleton page for the home page.
 */
const HomeSkeleton = memo(function HomeSkeleton(props) {
  const { config } = props;
  const { enable_rtl_orientation } = config;
  const [block, element] = bemify('home-skeleton');

  return (
    <div className={`${block()}${enable_rtl_orientation ? '--flipped' : ''}`}>
      <section className={element('search')}>
        <div className={element('title-shimmer')}>
          <Shimmer
            length={ShimmerLength.percent75}
            size={ShimmerSize.large} />  
        </div>
        <div className={element('search-shimmer')}>
          <Shimmer
            length={ShimmerLength.percent100}
            size={ShimmerSize.large} />
        </div>
        <div className={element('suggestions-shimmer')}>
          <Shimmer type={ShimmerType.square} />
          <Shimmer type={ShimmerType.square} />
          <Shimmer type={ShimmerType.square} />
          <Shimmer type={ShimmerType.square} />
        </div>
      </section>
      <section className={element('map')}>
        <div className={element('map-shimmer')}>
          <Shimmer
            size={ShimmerSize.large}/>
          <Shimmer
            length={ShimmerLength.percent50}
            size={ShimmerSize.large}/>
          <Shimmer
            length={ShimmerLength.percent75}
            size={ShimmerSize.large}/>
          <Shimmer
            length={ShimmerLength.percent100}
            size={ShimmerSize.large}/>
        </div>
      </section>
    </div>
  );
});

HomeSkeleton.propTypes = {
  config: PropTypes.object.isRequired,
};

export default withConfig((HomeSkeleton));

